import { useCopilotInstruction as e } from "./global-state.js";
import { createContext as t, useContext as n, useMemo as r } from "react";
import { jsx as i } from "react/jsx-runtime";
// src/react/markdown.tsx
var a = t(null);
function o() {
	let e = n(a);
	if (e == null) throw Error("Markdown must be used within CopilotProvider");
	return e;
}
function s({ children: t, markdown: n, library: o, libraryPromptOptions: s, mermaidComponent: c }) {
	let l = r(() => {
		let e = o == null ? null : o.prompt({
			...s,
			preamble: "When rendering UI, emit an `openui` code fence. Inside the fence, write valid openui-lang. Everything outside the fence is regular markdown."
		});
		return e == null ? "" : [
			"## Content Guidelines",
			"",
			"You can render rich UI components inline using an `openui` code fence. When you do, the fence content must be valid openui-lang — all syntax rules, component signatures, and streaming guidelines below apply to what goes inside the fence. Your prose outside the fence should remain standard markdown.",
			"",
			e
		].join("\n");
	}, [o, s]);
	e({
		instruction: l,
		isEnabled: l !== ""
	});
	let u = r(() => ({
		markdown: n,
		library: o ?? null,
		mermaidComponent: c ?? null
	}), [
		n,
		o,
		c
	]);
	return /* @__PURE__ */ i(a.Provider, {
		value: u,
		children: t
	});
}
export { s as CopilotProvider, o as useMarkdownContext };
